module.exports = __webpack_public_path__ + "ClientApp/content/VetResourceCenter/vet-pain-management.jpg";